<div class="d-flex align-items-center">
    <img [src]="user.headshot ? blobUrl + user.headshot : '/assets/default-avatar.png'" alt="avatar"
        [width]="40" [height]="40" class="avatar">
    <div class="ap-ml-spacing-3">
        {{user.firstName}} {{user.lastName}}
        <div class="ap-text-color-text-ligth ap-font-14">{{user.email}}</div>
    </div>
</div>